function useCustomFunctions() {
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return {
    numberWithCommas,
  };
}
export default useCustomFunctions;
